export default __webpack_public_path__ + "5bb136f01aab5eb2f4bb643e2c0b4b93.png";